// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"48fade8f","113":"36c8fec4","223":"595ee9d1","750":"1615bee2"}[chunkId] + ".chunk.js";
};